import React from 'react';
import styled from 'styled-components';
import { ColorPalettes, GlobalStyles } from 'kinedu-react-components';
import { Transition } from 'react-transition-group';
import { useTranslation } from 'react-i18next';

import Texture from '../../images/Texture2.png';
import BabyCrawlingSequence from '../../images/babyCrawlingSequence.png';
const { KineduPalette, MiscPalette } = ColorPalettes;
export interface SplashScreenProps {
  loading?: boolean;
}

const BabyAnimated = styled.div`
  width: 210px;
  height: 160px;
  background-image: url(${BabyCrawlingSequence});
  background-position: left center;
  background-size: cover;

  @keyframes babyCrawling {
    100% {
      background-position: -12800px;
    }
  }

  animation: babyCrawling 3s steps(30) infinite;
`;

interface IScreen {
  show: boolean;
}

const Screen = styled.div`
  background-color: ${KineduPalette.physical};
  background-image: url(${Texture});
  z-index: 3;
  ${GlobalStyles.fullBleed('fixed')};
  flex-direction: column;
  opacity: 1;
  /* ${({ show }: IScreen) => GlobalStyles.fade(show, 1.5)} */
`;

const Title = styled.h1`
  color: ${MiscPalette.white};
  font-size: 20px;
  font-weight: bold;
`;

const SplashScreen: React.FC<SplashScreenProps> = ({
  loading,
}) => {
  const [t] = useTranslation('common', { useSuspense: false });
  return (
    <Transition in={loading} timeout={0} unmountOnExit>
      {(state: string) => (
        <Screen show={state === 'entered'}>
          <BabyAnimated />
          <Title>{t('LOADING')}</Title>
        </Screen>
      )}
    </Transition>
  );
};

SplashScreen.defaultProps = {

};

export default SplashScreen;
